<template>
  <global-modal name="event-modal-categories">
    <Modal @close="$modal.hide('event-modal-categories')">
      <section class="event-modal-categories">
        <div class="event-modal-categories__header">
          <button
            @click="back"
            class="event-modal-categories__prev button-clean"
            v-if="actives && actives.length"
          >
            <icon name="arrow-left" />
          </button>
          <h1 class="event-modal-categories__title">
            <template v-if="active">
              {{ active | localeField("name") }}
            </template>
            <template v-else>Категории</template>
          </h1>
        </div>
        <div class="event-modal-categories__body">
          <ul class="event-modal-categories__list">
            <li
              v-for="(item, i) in list"
              :key="i"
              class="event-modal-categories__item"
            >
              <router-link
                :to="{
                  name: 'category',
                  params: { id: $route.params.id, category_id: item.id }
                }"
                class="event-modal-categories__link"
              >
                <icon v-if="item.icon" :name="item.icon" />
                <span>{{ item | localeField("name") }}</span>
              </router-link>
              <button
                class="event-modal-categories__btn button-clean"
                @click="next(item)"
              >
                <icon name="arrow-drop-right" />
              </button>
            </li>
          </ul>
        </div>
      </section>
    </Modal>
  </global-modal>
</template>

<script>
import Modal from "@/components/Modal/Modal.vue";
import { mapGetters } from "vuex";

import { i18n } from "@v2/shared/config";

export default {
  name: "EventModalCategories",
  components: {
    Modal
  },
  data() {
    return {
      // массив со всеми активными массивами категорий
      actives: []
    };
  },
  computed: {
    ...mapGetters("services", ["categories"]),

    locale() {
      return i18n.locale;
    },
    list() {
      return this.active ? this.active.children : this.categories;
    },
    active() {
      if (this.actives && this.actives.length) {
        return this.actives[this.actives.length - 1];
      }
      return null;
    }
  },
  methods: {
    next(item) {
      if (item.children && item.children.length) {
        this.actives.push(item);
      } else {
        this.$router.push({
          name: "category",
          params: { id: this.$route.params.id, category_id: item.id }
        });
      }
    },
    back() {
      this.actives.pop();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@v2/app/styles/mixins";
.event-modal-categories {
  width: 100%;
  height: 100%;

  & * {
    box-sizing: border-box;
  }

  &__header {
    padding: 30px 50px 30px 30px;
    display: flex;
    align-items: center;
  }

  &__prev {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    margin-right: 10px;
    border-radius: 50%;
    border: 1px solid var(--gray-darker, #d5dae5);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition);
    @media (max-width: 540px) {
      width: 30px;
      height: 30px;
    }

    &:hover {
      border-color: var(--main, #009ee3);
      background: var(--main, #009ee3);

      svg {
        color: var(--white, #fff);
      }
    }

    svg {
      width: 20px;
      height: 20px;
      color: var(--gray-dark, #a3a8b3);
    }
  }

  &__title {
    @include h1();
  }

  &__list {
    display: flex;
    flex-direction: column;
    list-style: none;
    margin: 0;
    padding: 0;
  }

  &__item {
    border-bottom: 1px solid var(--gray-darker, #d5dae5);
    display: grid;
    grid-template-columns: 1fr auto;
    min-height: 50px;

    &:first-child {
      border-top: 1px solid var(--gray-darker, #d5dae5);
    }
  }

  &__link {
    display: flex;
    align-items: center;
    font-size: 0.875rem;
    line-height: 22px;
    flex-grow: 1;
    padding: 5px 20px;
    color: var(--dark, #262626);
    text-decoration: none;
    transition: var(--transition);

    &:hover {
      background: var(--main, #009ee3);
      color: var(--white, #fff);

      svg {
        color: var(--white, #fff);
      }
    }

    svg {
      flex-shrink: 0;
      color: var(--dark, #262626);
      width: 30px;
      height: 30px;
      padding: 5px;
      margin-right: 5px;
    }
  }

  &__btn {
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 50px;
    border-left: 1px solid var(--gray-darker, #d5dae5);
    border-right: 1px solid var(--gray-darker, #d5dae5);
    transition: var(--transition);

    &:hover {
      background: var(--main, #009ee3);

      svg {
        color: var(--white, #fff);
      }
    }

    svg {
      width: 18px;
      height: 18px;
    }
  }
}
</style>
